<div>
  <div class="cooking-header" (swipedown)="swipe($event.type)">
    <div class="title">
      <img src="assets/plans/edit-blue.svg" alt="" />

      <p>تاریخ انقضا</p>
    </div>
    <img src="assets/cookingbook/angle-down.svg" (click)="goBack()" alt="" />
  </div>
  <div>
    <app-date [type]="'expire'" [expire]="true"></app-date>
  </div>
  <div class="button" (click)="submit()">ثبت کنید</div>
</div>
